import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoDerechoArco from "../derechoarco/InfoDerechoArco";
const Footer = lazy(() => import('../footer/Footer'));
function DerechoArco() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai cuenta con una alta gama de repuestos originales. Cotiza el que tu necesites."
        />
        <meta
          name="keywords"
          content="Repuestos Hyundai, Repuesto, red de servicio, servicio Hyundai"
        />
        <title>Protección de datos</title>
      </Helmet>
      <Menu />
      <InfoDerechoArco />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default DerechoArco;